module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("g1SM2"))).then(() => parcelRequire('2KbAe'));